import { useApi } from "@/core/http";
import { defineStore } from "pinia";

const { get_data } = useApi();

export const useMenusStore = defineStore('menuStore', {
    state: () => ({
        getDisplayMenu: 'default',
        menuList: [],
    }),
    getters: {
        filteredMenus: (state) => {
            if (typeof state.menuList !== 'object') {
                console.log("menuList n'est pas un object", state.menuList);
                return [];
            }

            const menuGroup = state.menuList[state.getDisplayMenu] || [];
            return menuGroup.filter(item => {
                const displayMatches = item.display_menu === state.getDisplayMenu;
                const titleMatches = state.getDisplayMenu === 'default' || item.parent_id !== null;
                
                if (item.hideInMenu === "1") return false;

                return displayMatches && titleMatches;
            }).map(item => ({
                path: item.page_url,
                icon: item.icon,
                title: item.page_title,
                headline: item.headline,
                display: item.display_menu,
                num_rows: item.row_numb || 0
            }));
        }
    },
    actions: {
        async fetchRoutes() {
            try {
                const response = await get_data('/menus');
                if (!response?.data) throw new Error("Problème de connexion au serveur");

                this.menuList = response.data;
                this.updateMenus();
            } catch (error) {
                console.log(error.message || error);
            }
        },
        generateRoutes() {
            const routeGroups = ["default", "settings", "configs", "accounts", "authentication", "error", "dataforms"];
            const dynamicRoutes = routeGroups.flatMap(group => {
                return (this.menuList[group] || []).map(item => ({
                    path: item.page_url,
                    name: item.page_title,
                    component: () => import(`@/pages/${item.display_view.charAt(0).toUpperCase() + item.display_view.slice(1)}.vue`),
                    meta: {
                        requiresAuth: item.requiresAuth === '1' ? true : false,
                        headline: item.headline,
                        icon: item.icon,
                        display: item.display_menu,
                        table: item.display_table,
                        page: item.display_view,
                        title: item.parent_id === null ? true : false,
                        hideInMenu: item.hideInMenu === '1' ? true : false,
                        num_rows: item.row_numb || 0
                    }
                }))
            });
            return dynamicRoutes;
        },
        isActive(route, url) {
            return route.path === url ? true : false;
        },
        redirectUrl(display, router) {
            this.setDisplayMenu(display);
            router.push(display === 'default' ? '/' : `/${display}`);
        },
        updateMenus() {
            if (!this.menuList[this.getDisplayMenu]) {
                this.setDisplayMenu('default');
            }
        },
        setDisplayMenu(menuType) {
            this.getDisplayMenu = menuType;
        },
    }
});